const PATIENT_EXPERIENCE_USER_NAME = "Patient";

export const isPatientExperienceUser = (user) => Boolean(user?.isPatientExperienceUser);

export const formatName = (user) => {
  if (!user) return user;
  return isPatientExperienceUser(user) ? PATIENT_EXPERIENCE_USER_NAME : `${user.firstName} ${user.lastName}`;
};
